import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'pulse-slide',
  templateUrl: './slide.component.html',
  styleUrls: ['./slide.component.scss'],
})
export class SlideComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
